import { Checkbox } from '@systemeio/ui'
import ContactFilterAddButton from 'modules/contacts/components/contact-filter-add-button'
import ContactFilterSkeleton from 'modules/contacts/components/contact-filter-skeleton'
import { ContactSearchFieldEnum } from 'modules/contacts/enums/contact-enum'
import { ContactFilterType } from 'modules/contacts/types/contact-filter-interface'
import { isFilterFiledEmpty } from 'modules/contacts/utils/is-filter-filed-empty'
import React, { useEffect, useState } from 'react'
import { twMerge } from 'tailwind-merge'

interface ContactFilterWrapperProps {
  isFetching: boolean
  lastElement?: boolean
  children: JSX.Element
  title: string
  slug: string
  addFilter: (slug: string) => void
  clearClosingState: () => void
  needToCloseFilters: boolean
  clearFilterField: (slug: string) => void
  filter: ContactFilterType
}

export const ContactFilterWrapper = ({
  clearClosingState,
  needToCloseFilters,
  clearFilterField,
  isFetching,
  lastElement,
  children,
  filter,
  slug,
  addFilter,
  title,
}: ContactFilterWrapperProps) => {
  const [opened, setOpened] = useState(!isFilterFiledEmpty({ filter, slug }))

  useEffect(() => {
    if (!opened) {
      clearFilterField(slug)
    } else {
      clearClosingState()
    }
  }, [clearClosingState, clearFilterField, opened, slug])

  useEffect(() => {
    if (needToCloseFilters) {
      setOpened(false)
    }
  }, [needToCloseFilters])

  useEffect(() => {
    if (!isFilterFiledEmpty({ filter, slug })) {
      setOpened(true)
    }
  }, [filter, slug])
  return isFetching ? (
    <ContactFilterSkeleton isLast={lastElement || false} />
  ) : (
    <div
      className={twMerge(!lastElement && 'border-b-text-secondary/30 border-b pb-3', 'w-full px-4')}
    >
      <div className={'flex items-center gap-3'}>
        <div className={`flex w-full flex-col gap-3`}>
          <div
            className={'flex cursor-pointer justify-between gap-3'}
            onClick={() => setOpened(!opened)}
          >
            <span
              className={`${opened && 'text-text-primary'} main-transition-colors truncate ${
                opened ? 'font-semibold' : 'font-normal'
              }`}
            >
              {title}
            </span>
            <Checkbox
              className={'pointer-events-none'}
              value={opened}
              onChange={value => setOpened(value)}
            />
          </div>
          {opened && (
            <>
              {children}
              {slug !== ContactSearchFieldEnum.affiliate && (
                <ContactFilterAddButton
                  onClick={e => {
                    e.preventDefault()
                    addFilter(slug)
                  }}
                />
              )}
            </>
          )}
        </div>
      </div>
    </div>
  )
}

export default ContactFilterWrapper
